import { RenderingSubsection } from '@zinnia/form-engine-sdk';

import { ReactElement } from 'react';
import { AuraNextMedicalQuestionnaireSubsection } from './AuraNextMedicalQuestionnaireSubsection/AuraNextMedicalQuestionnaireSubsection';

type CustomSubsectionProps = {
  subsection: RenderingSubsection;
};

export function CustomSubsection({ subsection }: CustomSubsectionProps): ReactElement | null {
  switch ((subsection as any).custom.name) {
    case 'AuraNextMedicalQuestionnaire':
      return <AuraNextMedicalQuestionnaireSubsection subsection={subsection} />;
    default:
      return null;
  }
}
